@if (text$ | async; as text) {
  @if ({groups: (slideViewerFacade.currentSelectedSlideGroups$ | async), themeColor: (slideViewerFacade.themeColor$ | async)}; as data) {
    <div #textElement (click)="onLinkClick($event)" (mouseout)="onLinkOut($event)" (mouseover)="onLinkOver($event)">
      <medsurf-text-format [text]="test$ | async"></medsurf-text-format>
    </div>
  }
}


